export default __webpack_public_path__ + "static/media/Coin98.1e4e4073.png";